import { isEmpty } from 'lodash';
import React from 'react';

import usePermissions from '@app/hooks/usePermissions';

type PermissionProps = {
    permissions: string[];
    hasAny?: boolean;
    children: React.ReactNode;
    fallback?: Function;
    interceptor?: Function;
};

const Permission = ({
    permissions,
    hasAny = false,
    children,
    fallback = null,
    interceptor = () => false,
}: PermissionProps) => {
    const { hasAllPermissions, hasAnyPermissions } = usePermissions();
    const hasPermission = hasAny ? hasAnyPermissions : hasAllPermissions;

    if (!isEmpty(permissions) && !hasPermission(permissions)) {
        return fallback ? fallback() : null;
    }

    if (interceptor()) {
        return fallback ? fallback() : null;
    }

    return children;
};

export default Permission;
